import { render, staticRenderFns } from "./app_home.vue?vue&type=template&id=31812d96&"
import script from "./app_home.vue?vue&type=script&lang=js&"
export * from "./app_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports